import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const AnnouncementTicker = () => {
  const [tickerText, setTickerText] = useState(
    'Premium Designer Ladies Wear at Gokul Road, Hubli — Visit Us! | Free Consultation on WhatsApp: +91 95387 69669 | New Festive Collections Arrived'
  );

  useEffect(() => {
    const fetchTickerText = async () => {
      try {
        const response = await api.get('/settings/ticker_text');
        if (response.data.value) {
          setTickerText(response.data.value);
        }
      } catch (error) {
        console.error('Error fetching ticker text:', error);
      }
    };

    fetchTickerText();
  }, []);

  return (
    <div data-testid="announcement-ticker" className="bg-[#E5A93C] border-b border-[#2A0000]/10 overflow-hidden py-2">
      <div className="flex whitespace-nowrap">
        <div className="animate-marquee flex items-center space-x-8">
          <span className="text-[#2A0000] font-bold text-sm tracking-wide">{tickerText}</span>
          <span className="text-[#2A0000] font-bold text-sm tracking-wide">{tickerText}</span>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementTicker;
